import { Api } from '../api';
import { file } from '../endpoints';
import type { FileEntity, FileItem, FileTypeEntity, IFile } from './models';
import type { ManualApplicationFileSearchParams } from '../application';

export class FileApi extends Api {
  static getFileTypes = (signal?: AbortSignal) => this.get<FileTypeEntity[]>({ url: file.getTypes(), signal });

  static getApplicationFiles = (applicationId: string, signal?: AbortSignal) =>
    this.get<FileEntity[]>({ url: file.getApplicationFiles(applicationId), signal });

  static downloadApplicationFile = (fileId: string, signal?: AbortSignal) => this.get<IFile>({ url: file.downloadFile(fileId), signal });

  static deleteApplicationFile = (fileId: string, signal?: AbortSignal) =>
    this.delete<ManualApplicationFileSearchParams>({ url: file.deleteFile(fileId), signal });

  static uploadApplicationFile = (searchParams: File[], manualApplicationId?: string) => {
    const formData = searchParams.reduce((curData, file) => {
      curData.append('files', file);
      // @ts-ignore
      curData.append('documentTypes', file.fileType);
      return curData;
    }, new FormData());
    if (manualApplicationId) formData.append('manualApplicationId', manualApplicationId);

    return this.post<FormData>({ url: file.uploadFile(), data: formData, headers: { 'Content-Type': 'multipart/form-data' } });
  };

  static uploadFiles = (searchParams: FileItem[], selectedApplicationId: string) => {
    const formData = searchParams.reduce((curData, file) => {
      curData.append('files', file as unknown as File);
      // @ts-ignore
      curData.append('documentTypes', file.fileType);
      if (file.country) curData.append('country', file.country);
      if (file.expiryDate) curData.append('expireDate', file.expiryDate);
      if (file.citizenByInvestment !== undefined) curData.append('citizenshipBytInvestment', file.citizenByInvestment ? 'true' : 'false');
      if (file.number) curData.append('number', file.number);
      // file.
      return curData;
    }, new FormData());

    formData.append('selectedApplicationId', selectedApplicationId);

    return this.post<FormData>({ url: file.uploadFile(), data: formData, headers: { 'Content-Type': 'multipart/form-data' } });
  };
}
